import React from 'react';

import DialogWithInfoLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithInfoLayout';

const GSFNNotFoundDialog = ({ message, ...otherProps }) => {
  return (
    <DialogWithInfoLayout
      {...otherProps}
      size='md'
      movable={false}
      closeBtn={false}
    >
      {message}
    </DialogWithInfoLayout>
  );
}

export const typeOfGSFNNotFoundDialog = 'typeOfGSFNNotFoundDialog';
export default GSFNNotFoundDialog;
